export default __webpack_public_path__ + "static/media/oscer-logo-blue.99324246.png";